export default __webpack_public_path__ + "static/media/cows-mote-1200x628.b81146e3.jpg";